<template>
    <div class="adv-range" ref="range">
        <p class="adv-price-range" v-if="isMobileSize">
            {{ $t("common:signLog.adv.price") }}
            Price:
            <span>{{
                format(resultRange[0]) + ' - ' + format(resultRange[1], false)
            }}</span>
        </p>
        <div class="adv-range-thumb" ref="thumb">
            <div
                class="adv-range-operator-prev"
                :class="{ 'show-tips': showTips }"
                :style="prevStyle"
                ref="prev"
            >
                <p
                    class="adv-range-tips"
                    v-if="!isMobileSize && showTips"
                    ref="prevTip"
                >
                    {{
                        isOverlapFlag
                            ? format(resultRange[0]) +
                                ' - ' +
                                format(resultRange[1], false)
                            : format(resultRange[0])
                    }}
                </p>
            </div>
            <div
                class="adv-range-operator-next"
                :class="{ 'show-tips': showTips }"
                :style="nextStyle"
                ref="next"
            >
                <p
                    v-if="!isMobileSize && showTips"
                    class="adv-range-tips"
                    ref="nextTip"
                    :style="{ visibility: isOverlapFlag ? 'hidden' : 'unset' }"
                >
                    {{ format(resultRange[1]) }}
                </p>
            </div>
            <div class="adv-range-bar" :style="barStyle" ref="bar"></div>
            <span
                class="adv-range-doc-wrap"
                :style="{ left: index * stepDis + 'px' }"
                @click="setPos(val, index)"
                v-for="(val, index) in ticks"
                :key="index"
            ><b
                v-show="typeof val === 'number'"
                :class="[
                    'adv-range-dot',
                    val > resultRange[0] && val < resultRange[1]
                        ? 'inner'
                        : 'outer'
                ]"
            ></b
            ></span>
        </div>
        <div class="adv-range-label">
            <span
                v-for="(val, index) in ticks"
                :key="index"
                :style="{
                    left: index * stepDis + 10 + 'px',
                    width: stepDis + 'px'
                }"
                @click="setPos(val, index)"
            >
                {{
                    isMobileSize && index != 0 && index != ticks.length - 1
                        ? ''
                        : format(val)
                }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdvRange',
    props: {
        unit: {
            type: String,
            default: '$'
        },
        fixed: {
            type: Number,
            default: 0
        },
        showZeroTick: {
            type: Boolean,
            default: false
        },
        step: {
            type: Number,
            default: 0
        },
        ticks: {
            type: Array,
            default: () => []
        },
        defaultValue: {
            type: Array,
            default: () => [0, 10]
        },
        showTips: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        const range = this.defaultValue.map(v => {
            return { index: this.ticks.indexOf(v), value: v, left: 0 };
        });
        return {
            prev: 0,
            next: 0,
            thumbWidth: 0,
            range, //  [{index:0,value:0,left:0}]
            stepDis: 0, // step pixel length in interval
            tipDirection: ['top', 'top'],
            isOverlapFlag: false
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile
        },
        prevStyle({ range, stepDis }) {
            return {
                left: range[0].index * stepDis + 'px'
            };
        },
        nextStyle({ range, stepDis }) {
            return {
                left: range[1].index * stepDis + 'px'
            };
        },
        barStyle({ range, stepDis }) {
            return {
                left: range[0].index * stepDis + 10 + 'px',
                width:
                    range[1].index * stepDis - range[0].index * stepDis + 'px'
            };
        },
        resultRange({ range }) {
            const val = range.map(v => v.value);
            this.$emit(
                'change',
                range.map(v => v.value)
            );
            return val;
        }
    },
    mounted() {
        let timer = null;
        const validateWidth = () => {
            timer && clearTimeout(timer);
            timer = setTimeout(() => {
                this.thumbWidth = this.$refs.thumb.offsetWidth - 15;
                if (this.thumbWidth <= 0 || !this?.thumbWidth) {
                    validateWidth();
                    return;
                }
                this.range = this.defaultValue.map(v => {
                    const i = this.ticks.indexOf(v);
                    return {
                        index: i,
                        value: v,
                        left: i * this.stepDis
                    };
                });
                this.stepDis = this.thumbWidth / (this.ticks.length - 1);
                // this.rangeNums = this.computedRangeNums();
                this.bindDrag(this.$refs.prev, 'prev');
                this.bindDrag(this.$refs.next, 'next');

                // add animation
                this.$refs.range.addEventListener('transitionend', () => {
                    this.$nextTick(() => {
                        this.isOverlap();
                    });
                });
                this.$nextTick(() => {
                    this.addTransition();
                });
            });
        };
        validateWidth();
    },
    methods: {
        setPos(val, index) {
            const { prev, next } = this.$refs;
            const prevLeft = this.getElLeft(prev);
            const nextLeft = this.getElLeft(next);
            const target = index * this.stepDis;
            let rangeIndex = 0;
            if (Math.abs(target - prevLeft) > Math.abs(target - nextLeft)) {
                rangeIndex = 1;
            } else {
                rangeIndex = 0;
            }
            const obj = {
                index,
                value: val,
                left: target
            };
            this.range[rangeIndex] = obj;
        },
        isOverlap() {
            if (this.isMobileSize || !this.showTips) {
                return; 
            }
            const { prevTip, nextTip } = this.$refs;
            const [prevInfo, nextInfo] = [prevTip, nextTip].map(v => {
                return v.getBoundingClientRect();
            });
            const isOverlapFlag =
                prevInfo.left + prevInfo.width > nextInfo.left;
            this.isOverlapFlag = isOverlapFlag;
            return isOverlapFlag;
        },
        modifyTipPos() {
            const newPos = ['top', 'top'];
            const isOverlapFlag = this.isOverlap();
            if (isOverlapFlag) {
                newPos[1] = 'bottom';
            }
            this.tipDirection = newPos;
            return isOverlapFlag;
        },
        //  Calculate the interval point according to the step size
        computedRangeNums() {
            const { range, step, value2px } = this;
            const nums = (range[1] - range[0]) / step;
            const numsInt = parseInt(nums);
            return [...new Array(numsInt).keys()]
                .map(v => v + 1)
                .map(val => {
                    const value = val * step + range[0];
                    const left = value2px(value);
                    return { left, value };
                });
        },
        px2value(px) {
            const { range, thumbWidth } = this;
            return (px / thumbWidth) * (range[1] - range[0]) + range[0];
        },
        value2px(val) {
            const {
                range: [start, end],
                thumbWidth
            } = this;
            return ((val - start) / (end - start)) * thumbWidth;
        },
        bindDrag(el, key) {
            let pos,
                dis,
                _this = this,
                body = document.body;
            const event = {
                start: this.isMobileSize ? 'touchstart' : 'mousedown',
                end: this.isMobileSize ? 'touchend' : 'mouseup',
                move: this.isMobileSize ? 'touchmove' : 'mousemove'
            };
            el.addEventListener(event.start, e => {
                pos = this.isMobileSize
                    ? e.targetTouches[0].clientX
                    : e.clientX;
                _this.removeTransition();
                body.addEventListener(event.move, mousemoveFn);
                body.addEventListener(event.end, mouseupFn);
                // body.addEventListener('mouseout', mouseupFn);
                function mousemoveFn(e) {
                    const { ticks, range, stepDis, isMobileSize } = _this;
                    let clientX = isMobileSize
                        ? e.targetTouches[0].clientX
                        : e.clientX;
                    dis = clientX - pos;
                    const direction = dis < 0 ? 'left' : 'right';
                    if (Math.abs(dis) >= stepDis / 1.5) {
                        let res = key === 'prev' ? range[0] : range[1],
                            i = 0;

                        if (direction === 'left') {
                            i = res.index < 1 ? 0 : res.index - 1;
                        } else {
                            i =
                                res.index >= ticks.length - 1
                                    ? ticks.length - 1
                                    : res.index + 1;
                        }

                        if (key === 'prev') {
                            i === range[1].index && (i = range[1].index - 1); 
                        }

                        if (key === 'next') {
                            i === range[0].index && (i = range[0].index + 1); 
                        }

                        res = {
                            index: i,
                            value: ticks[i],
                            left: stepDis
                        };

                        const index = key === 'prev' ? 0 : 1;
                        _this.range[index] = res;
                        pos = clientX;
                        // tips  Impact checking
                        _this.$nextTick(_this.isOverlap);
                    }
                }
                function mouseupFn() {
                    body.removeEventListener(event.move, mousemoveFn);
                    body.removeEventListener(event.end, mouseupFn);
                    _this.addTransition();
                }
            });
        },
        removeTransition() {
            this.$refs.prev.style.transition =
                this.$refs.next.style.transition =
                this.$refs.bar.style.transition =
                    'unset';
        },
        addTransition() {
            const transitionStyle = 'left ease .3s';
            this.$refs.prev.style.transition =
                this.$refs.next.style.transition = transitionStyle;
            this.$refs.bar.style.transition = 'all ease .3s';
        },
        getElLeft(el) {
            return +el?.style?.left?.replace('px', '');
        },
        format(val, withUnit = true) {
            let res;
            val = `${val}`;
            if (val.indexOf('.') === -1) {
                res = this.fixed
                    ? `${val}.`.padEnd(val.length + this.fixed + 1, '0')
                    : val;
            } else {
                const descReg = /([1-9][0-9]*\.)([0-9]+)/g;
                res = val.replace(descReg, (_, a, b) => {
                    if (b.length > this.fixed) {
                        return a + b.substring(0, this.fixed);
                    } else {
                        return a + b.padEnd(this.fixed, '0');
                    }
                });
            }

            res = +res;
            if (Number(res) < 1000) {
                return `${withUnit ? this.unit : ''}${res}`;
            }

            let newValue = res > 1e6 ? res / 1e6 : res / 1e3;
            if (this.fixed) {
                newValue = newValue.toFixed(this.fixed);
            }
            return `${withUnit ? this.unit : ''}${newValue}${
                res > 1e6 ? 'M' : 'K'
            }`;
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.adv-range {
    padding-top: 45px;
    user-select: none;
    @include media-600 {
        padding-top: 0;
    }
    .adv-price-range {
        font-size: 12px;
        color: #a0a3af;
        @include media-600 {
            margin-bottom: 24px;
            margin-top: 30px;
        }
        span {
            color: #4c84ff;
        }
    }
    .adv-range-label {
        position: relative;
        width: 100%;
        padding-bottom: 22px;
        span {
            position: absolute;
            top: 0;
            font-size: 12px;
            line-height: 1.4;
            color: #797e8b;
            transform: translateX(-50%);
            padding-top: 5px;
            cursor: pointer;
            &:after {
                content: '';
                width: 1px;
                height: 4px;
                position: absolute;
                left: 50%;
                top: -1px;
                background: #c6c8d1;
            }
        }
    }
    .adv-range-thumb {
        width: 100%;
        height: 8px;
        background-color: #ebecf1;
        border-radius: 4px;
        position: relative;
        margin-bottom: 10px;
        div[class^='adv-range-operator-'] {
            width: 20px;
            height: 20px;
            position: absolute;
            border-radius: 50%;
            background-color: #fff;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            box-shadow: 0 0 4px 0 rgba(0, 10, 30, 0.25);
            cursor: pointer;
            z-index: 4;
            &::before {
                content: '';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #4c84ff;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
            &.show-tips::after {
                content: '';
                width: 0;
                height: 0;
                border-left: 4px solid transparent;
                border-right: 4px solid transparent;
                border-bottom: 4px solid rgba(76, 132, 255, 0.15);
                position: absolute;
                left: 50%;
                top: 0;
                transform: translate(-50%, -100%);
            }
            @include media-600 {
                &::after {
                    display: none;
                }
            }
            .adv-range-tips {
                position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%, calc(-100% - 5px));
                padding: 6px 10px 9px;
                background-color: rgba(76, 132, 255, 0.15);
                font-size: 12px;
                font-weight: 600;
                line-height: 1.8;
                text-align: center;
                color: #4c84ff;
                white-space: nowrap;
                // &:before {
                //     content: '';
                //     width: 0;
                //     height: 0;
                //     border-left: 4px solid transparent;
                //     border-right: 4px solid transparent;
                //     border-top: 4px solid rgba(76, 132, 255, 0.15);
                //     position: absolute;
                //     left: 50%;
                //     bottom: 0;
                //     transform: translate(-50%, 4px);
                // }
                // &.bottom {
                //     top: unset;
                //     bottom: -42px;
                //     transform: translate(-50%, 0);
                //     &:before {
                //         border-top: unset;
                //         border-bottom: 4px solid rgba(76, 132, 255, 0.15);
                //         bottom: unset;
                //         top: 0;
                //         transform: translate(-50%, -4px);
                //     }
                // }
            }
        }
        .adv-range-doc-wrap {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            position: absolute;
            top: 0;
            background: transparent;
            cursor: pointer;
            z-index: 3;
            // &:hover {
            //     .adv-range-dot {
            //         opacity: 0.8;
            //     }
            // }
            .adv-range-dot {
                position: absolute;
                top: 50%;
                left: 50%;
                width: 36px;
                height: 15px;
                transform: translate(-30%, -50%);
                opacity: 1;
                border-radius: 50%;
                opacity: 0;
                &.inner {
                    background-color: #fff;
                }
                &.outer {
                    background-color: #c6c8d1;
                }
            }
        }

        .adv-range-bar {
            position: absolute;
            height: 100%;
            left: 0;
            background-color: #4c84ff;
            z-index: 2;
            transition: all ease 0.3s;
        }
    }
}
</style>
